(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("codemirror"));
	else if(typeof define === 'function' && define.amd)
		define(["codemirror"], factory);
	else if(typeof exports === 'object')
		exports["CypherCodeMirror"] = factory(require("codemirror"));
	else
		root["CypherCodeMirror"] = factory(root["codemirror"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_25__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition